// extracted by mini-css-extract-plugin
module.exports = {"guideContainer":"guideContainer___3saH0","blockContainer":"blockContainer___wFOC3","blockItem":"blockItem___aJ-IM"};